import React from "react";
import { connect } from "react-redux";
import { actions as modalActions } from "../../../../redux/modals";
import { actions as routerActions } from "../../../../redux/router";
import { Translation, t } from "../../../core/translate";
import styled, { withTheme } from "styled-components";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import Cart from "./../../../components/icons/StoreCart";
import { Clients } from "../../library/header/slideout/icons";
import { Dialog, Button } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";
import { addParameter } from "../../../utils/location";
import LibraryHelpers from "../../../../stores/library-helpers";
import { downloadApp, launchInApp } from "../../../utils/read-offline";
import Spinner from "./../../../components/spinner";

const Styled = {
  SplitBox: styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
  `,
  CTAContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    padding-bottom: 10px;
    width: 150px;
    button,
    a {
      margin: 25px 0;
    }
    svg {
      width: 150px;
      height: 100px;
    }
  `,
  Footer: styled.div`
    text-align: right;
  `,
  Warning: styled.div`
    padding: 10px 0;
    font-style: italic;
    color: ${cloud.getShade(10)};
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    width: 226px;
    text-align: left;
    padding-right: 10px;
  `,
  LeftBox: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 50%;
    border-right: 1px solid ${cloud.getShade(4)};
    padding-right: 20px;
  `,
  RightBox: styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    width: 50%;
  `,
  Heading: styled.h2`
    color: ${props => props.theme.vstui.color.primary.getShade(6)};
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    width: 192px;
    text-align: left;
    height: 50px;
  `,
  LearnMoreBtn: createThemedComponent(Button, {
    Button_fontWeight_naked: 400
  }),
  CustomDialog: createThemedComponent(Dialog, {
    Dialog_width_large: "550px"
  }),
  smallDialog: createThemedComponent(Dialog, {
    Dialog_width_small: "336px",
    DialogTitle_color_primary: cloud.getShade(10)
  }),
  DownloadLink: createThemedComponent(Button, {
    Button_paddingHorizontal_medium: 0
  })
};
const SmallDialog = styled(Styled.smallDialog)`
  div > h2 {
    text-align: center;
  }
`;

class ExpiredBookDialog extends React.Component {
  constructor() {
    super();
    this.state = { launching: false };
  }

  render() {
    if (this.state.launching) {
      const appUrl = Fraction.Helpers.getAppURL();
      const downloadLink = (
        <Styled.DownloadLink href={appUrl} naked target="_blank">
          <Translation id="recent-expired.download">
            Download the app.
          </Translation>
        </Styled.DownloadLink>
      );
      return (
        <SmallDialog
          closeButtonLabel={t("base.close", "Close")}
          onRequestClose={this.props.closeModal}
          open
          rootSelector="#main"
          size="small"
          title={t("recent-expired.launching", "Launching App")}
        >
          <Translation id="recent-expired.launch-fail" link={downloadLink}>
            If the application does not launch, try again or ${downloadLink}
          </Translation>
        </SmallDialog>
      );
    }
    return (
      <Styled.CustomDialog
        closeButtonLabel={t("base.close", "Close")}
        onRequestClose={this.props.closeModal}
        open
        darkHeader
        rootSelector="#main"
        size="large"
        title={t("recent-expired.get-access", "Get Access")}
      >
        <Styled.SplitBox>
          <Styled.LeftBox>
            <Styled.Heading>
              <Translation id="recent-expired.mobile-apps">
                Lifetime Access on our Mobile & Desktop Apps
              </Translation>
            </Styled.Heading>
            <Styled.CTAContainer>
              <Clients />
              <Button
                fullWidth
                onClick={() => {
                  this.setState({ launching: true }, () => {
                    launchInApp(this.props.isbn, true);
                  });
                }}
              >
                <Translation id="recent-expired.launch">Launch App</Translation>
              </Button>
            </Styled.CTAContainer>
            <div>
              <Translation id="recent-expired.lifetime">
                If you purchased lifetime access to a title, download our
                Bookshelf app to enjoy your purchase forever.
              </Translation>
              <Styled.Warning>
                <Translation id="recent-expired.one-year">
                  Online access is available for one year.
                </Translation>
              </Styled.Warning>
            </div>
          </Styled.LeftBox>
          <Styled.RightBox>
            <Styled.Heading>
              <Translation id="recent-expired.more-heading">
                More Access Options
              </Translation>
            </Styled.Heading>
            <Styled.CTAContainer>
              <Cart />
              <Button
                fullWidth
                href={`/#/redirect/${encodeURIComponent(
                  this.props.storeUrl
                )}?sso=true`}
                target="_blank"
              >
                <Translation id="recent-expired.purchase-options">
                  Purchase Options
                </Translation>
              </Button>
            </Styled.CTAContainer>

            <div>
              <Translation id="recent-expired.rental-duration">
                Your rental duration may have expired. Not done? Purchase the
                title again.
              </Translation>
            </div>
          </Styled.RightBox>
        </Styled.SplitBox>
        <Styled.Footer>
          <Styled.LearnMoreBtn
            naked
            inline
            target="_blank"
            href={this.props.SupportUrl}
          >
            <Translation id="recent-expired.learn-more">
              Learn more about book access
            </Translation>
          </Styled.LearnMoreBtn>
        </Styled.Footer>
      </Styled.CustomDialog>
    );
  }
}

const mapStateToProps = (state, props) => ({
  storeUrl: brandSelectors.storeProductsUrl(state, props.isbn),
  SupportUrl: brandSelectors.getBrandValue(
    state,
    "Support.url",
    t(
      "locations.zendesk-missing-books",
      "https://support.vitalsource.com/hc/en-us/articles/360036677273"
    )
  )
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(modalActions.closeModal())
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(ExpiredBookDialog)
);
